export const updateSelectedOption = (productOption) => (dispatch) => {
  dispatch({
    type: 'UPDATE_PRODUCT_OPTION_STATE',
    payload: productOption,
  })
}

export const clearSelectedOption = (productId) => (dispatch) => {
  dispatch({
    type: 'CLEAR_PRODUCT_OPTION_STATE',
    payload: { productId },
  })
}

export const updateSurcharge = (surchargeCode) => (dispatch) => {
  dispatch({
    type: 'UPDATE_SURCHARGES_STATE',
    payload: { surchargeCode },
  })
}

export const resetCoverageDetailsState = () => (dispatch) => {
  dispatch({
    type: 'RESET_COVERAGE_DETAILS_STATE',
  })
}
